import { BehaviorSubject, Observable } from 'rxjs';

export class MaintenanceStateService {
  private readonly isMaintenance$ = new BehaviorSubject<boolean>(false);

  isMaintenance(): Observable<boolean> {
    return this.isMaintenance$.asObservable();
  }

  turnOnMaintenanceMode(): void {
    this.isMaintenance$.next(true);
  }
}
